import type { FileService } from './file.service';
import { InjectionToken } from '@angular/core';

export const FILE_SERVICE_V2 = new InjectionToken<FileService>('FILE_SERVICE_V2');
